var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 5.73107C16.7339 6.40635 16.184 6.8595 15.7005 7.36152C14.645 8.44997 13.4608 9.38293 12.1036 10.076C10.8307 10.729 9.4913 11.0756 8.04987 10.9867C6.91003 10.9156 5.84116 10.5736 4.83437 10.0449C3.03813 9.10304 1.56122 7.77469 0.270584 6.23309C-0.0886643 5.80215 -0.0975346 5.2246 0.257279 4.79811C1.65879 3.1099 3.26876 1.68826 5.26902 0.759742C6.45321 0.208853 7.69949 -0.0799188 9.0123 0.0178194C10.1122 0.10223 11.1412 0.439871 12.1169 0.937448C13.7225 1.75934 15.0752 2.90554 16.2771 4.23834C16.4057 4.3805 16.5255 4.53599 16.6585 4.67372C16.8271 4.85586 16.9246 5.06911 17 5.30013C17 5.44674 17 5.5889 17 5.73107ZM8.49782 9.16968C10.5158 9.17412 12.1524 7.53922 12.1613 5.51338C12.1701 3.49197 10.538 1.84819 8.51556 1.83931C6.49313 1.83042 4.85655 3.45643 4.84324 5.48672C4.83437 7.51257 6.47095 9.16079 8.49782 9.16968Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1232 5.50452C11.1232 6.94394 9.94344 8.12124 8.50645 8.12569C7.06058 8.12569 5.88083 6.9395 5.8897 5.4912C5.89413 4.05178 7.07832 2.87448 8.51532 2.87892C9.94788 2.88336 11.1232 4.06511 11.1232 5.50452Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.13b343c6e2f5014f1d2d4e7d86332425.svg";
export { ForwardRef as ReactComponent };